export enum ClassType {
  MINI_CLASS = 1,
  GROUP_CLASS,
  QUALITY_CLASS,
  VIP_CLASS,
  SUPER_CLASS,
  RECORD_CLASS = 100,
}

export enum RoleType {
  TEACHER = 1,
  ASSISTANT,
  STUDENT,
  AUDITOR,
  ADMIN,
  GUEST,
  PAD
}
